import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

import AdImage from "../AdImage/AdImage";
import "./AdDetailsImageGallery.css";

// === NOVO: Uvoz tvoje utility funkcije ===
// Preveri, če je pot pravilna glede na strukturo tvojih map
import { getImageUrl } from "../../utils/imageUtils";

const AdDetailsImageGallery = ({ images = [] }) => {
    // 1. Uredimo slike (primarna prva)
    const sortedImages = (images && images.length > 0)
        ? [...images].sort((a, b) => (b.is_primary ? 1 : 0) - (a.is_primary ? 1 : 0))
        : [];

    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    if (sortedImages.length === 0) {
        return (
            <div className="gallery-placeholder">
                <AdImage image={null} variant="full" alt="Oglas nima slik" />
            </div>
        );
    }

    // === POPRAVEK: Uporaba getImageUrl za Lightbox ===
    const slides = sortedImages.map((img) => {
        // Tvoja baza verjetno vrača 'image_url' kot ime datoteke (key)
        // Funkciji podamo ta ključ in zahtevamo 'full' varianto (visoka ločljivost)
        // Če želiš čisto originalno datoteko, uporabi 'original' namesto 'full'
        const fullResUrl = getImageUrl(img.image_url, 'full');

        return {
            src: fullResUrl,
            alt: "Slika oglasa"
        };
    });

    return (
        <div className="ad-gallery-container">
            {/* === INLINE GALERIJA (Na strani) === */}
            <div
                className="main-image-wrapper"
                onClick={() => setOpen(true)}
            >
                {/* AdImage verjetno že sama uporablja getImageUrl, zato tu pustimo objekt */}
                <AdImage
                    image={sortedImages[index]}
                    variant="full"
                    alt="Glavna slika"
                    className="main-img"
                />
                <div className="gallery-overlay">
                    <i className="fa-solid fa-expand"></i>
                </div>
            </div>

            {/* Trak s sličicami */}
            {sortedImages.length > 1 && (
                <div className="thumbnails-scroll-container">
                    {sortedImages.map((img, i) => (
                        <div
                            key={img.id || i}
                            className={`thumb-item ${i === index ? 'active' : ''}`}
                            onClick={() => setIndex(i)}
                        >
                            <AdImage
                                image={img}
                                variant="card"
                                alt={`Slika ${i + 1}`}
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* === LIGHTBOX (Celozaslonski način) === */}
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                index={index}
                slides={slides}
                on={{
                    view: ({ index: currentIndex }) => setIndex(currentIndex),
                }}
                plugins={[Zoom, Thumbnails, Counter]}
                // Nastavitve zooma
                zoom={{
                    maxZoomPixelRatio: 3,
                    scrollToZoom: true,
                }}
                // Prepreči cropanje
                carousel={{
                    padding: 0,
                    spacing: 0,
                }}
                styles={{ container: { backgroundColor: "rgba(0, 0, 0, 0.95)" } }}
            />
        </div>
    );
};

export default AdDetailsImageGallery;